import { Permission } from '@src/main/modules/roles/domain/permission.interface';
import { PermissionRepository } from '@src/main/modules/roles/domain/permission.repository';
import { api, TokenProvider } from '@src/main/shared/infrastructure/entity/axios';

const path = '/permissions';

export const createPermissionHttpRepository = (
  tokenProvider: TokenProvider,
): PermissionRepository => new PermissionHttpRepository(tokenProvider);

class PermissionHttpRepository implements PermissionRepository {
  private readonly tokenProvider: TokenProvider;

  constructor(tokenProvider: TokenProvider) {
    this.tokenProvider = tokenProvider;
  }

  private async getAuthToken(): Promise<string> {
    const token = await this.tokenProvider.getToken();
    if (!token) throw new Error('Authentication token is missing');
    return token;
  }

  async findAll(): Promise<Permission[]> {
    const token = await this.getAuthToken();
    const response = await api.get<Permission[]>(`${path}/all`, token);
    return response;
  }
}
